<template>

  <div class="form">
    <!-- <div style="background-color: white; border-top: 1px solid #817E7E;">
      <label class="tips">{{ $t('register.bind_mobile') }}</label>
    </div> -->

    <custom-mt-field
        v-model.trim="$v.auth.mobile.$model"
        :validationParam="$v.auth.mobile"
        :label="$t('register.phone')"
        type="number"
        state="success"
    ></custom-mt-field>

    <custom-mt-field
        v-model.trim="$v.auth.captcha.$model"
        :validationParam="$v.auth.captcha"
        :label="$t('register.sms_otp')"
        class="sms"
        state="success"
    >
        <mt-button :disabled="!canSendSMSCaptcha" class="send-sms-captcha-button" size="small" type="primary"
                  @click="sendCaptcha('SMS')">
          {{ this.sendSMSCaptchaButtonText }}
        </mt-button>
    </custom-mt-field>

    <!-- <custom-mt-field
        v-model.trim="$v.auth.email.$model"
        :validationParam="$v.auth.email"
        :label="$t('register.email')"
        type="text"
        state="success"
    ></custom-mt-field>

    <custom-mt-field
        v-model.trim="$v.auth.captcha_email.$model"
        :validationParam="$v.auth.captcha_email"
        :label="$t('register.email_otp')"
        class="sms"
        state="success"
    >
        <mt-button :disabled="!canSendEmailCaptcha" class="send-sms-captcha-button" size="small" type="primary"
                  @click="sendCaptcha('Email')">
          {{ this.sendEmailCaptchaButtonText }}
        </mt-button>
    </custom-mt-field> -->

    <!-- <div style="background-color: white">
      <label class="tips">{{ $t('register.password_note') }}</label>
    </div> -->

    <custom-mt-field
        v-model.trim="$v.auth.password.$model"
        :validationParam="$v.auth.password"
        :label="$t('register.password')"
        state="success"
        type="password"
    ></custom-mt-field>

    <custom-mt-field
        v-model.trim="$v.auth.password_confirmation.$model"
        :messages="validation_error_messages.password_confirmation"
        :validationParam="$v.auth.password_confirmation"
        type="password"
        state="success"
        :label="$t('register.confirm_password')"
    ></custom-mt-field>

    <div class="submitWidth" style="display: flex; justify-content: center;">
      <mt-button :disabled="$v.$invalid" class="ds-button-large mt-10 mb-10" type="primary" @click="signUp">
        {{ $t('register.submit') }}
      </mt-button>
    </div>


    <div class="link-wrapper">
      <span class="left-text">{{ $t('register.agreetment_note') }}</span>
      <span class="right-text" @click="onAgreement">《{{ $t('register.agreetment') }}》</span>
    </div>
  </div>
</template>

<script>
import { Indicator, Toast } from 'mint-ui'
import { mapMutations, mapState } from 'vuex'
import { registerByMobile } from '../../../api/memberRegister'
import { getSmsCaptcha, getEmailCode } from '../../../api/common'
import { maxLength, minLength, required, sameAs } from 'vuelidate/lib/validators'
import validator from '@src/util/validator'

import CustomMtField from '@src/components/basic/CustomMtField'

export default {
  name: 'RegisterByMobile',
  components: {
    CustomMtField
  },
  validations: {
    auth: {
      mobile: {
        required,
        mobile: validator.mobile
      },
      // email: {
      //   required,
      //   email: validator.isEmail
      // },
      password: {
        required,
        maxLength: maxLength(20),
        minLength: minLength(6)
      },
      password_confirmation: {
        required,
        maxLength: maxLength(20),
        minLength: minLength(6),
        sameAs: sameAs('password')
      },
      captcha: {
        required,
        maxLength: maxLength(6),
        minLength: minLength(6)
      },
      // captcha_email: {
      //   required,
      //   maxLength: maxLength(6),
      //   minLength: minLength(6)
      // },
      invitation_code: {
        maxLength: maxLength(10),
        minLength: minLength(10)
      }
    }
  },
  data () {
    return {
      auth: {
        mobile: '',
        email: '',
        captcha: '',
        captcha_email: '',
        password: '',
        password_confirmation: '',
        invitation_code: this.$route.query.invitation_code
      },
      validation_error_messages: {
        password_confirmation: {
          sameAs: this.$t('validation.sameAs', { eq: this.$t('member.profile.password') })
        }
      },
      sendSMSCaptchaButtonText: this.$t('register.send_otp'),
      sendEmailCaptchaButtonText: this.$t('register.send_otp'),
      timer: {
        interval: false,
        seconds: 60
      },
      email_timer: {
        interval: false,
        seconds: 60
      }
    }
  },
  computed: {
    ...mapState({
      inviter_id: state => state.member.inviterId
    }),
    canSendSMSCaptcha: function () {
      return !this.$v.auth.mobile.$invalid && !this.timer.interval
    },
    canSendEmailCaptcha: function () {
      return !this.$v.auth.email.$invalid && !this.email_timer.interval
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timer.interval)
    clearInterval(this.email_timer.interval)
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin'
    }),
    setCountdownToSendCaptchaButtonText (type, seconds) {
      if (seconds <= 0) {
        this[`send${type}CaptchaButtonText`] = this.$t('register.send_otp')
      } else {
        this[`send${type}CaptchaButtonText`] = this.$t('register.countdown_to_resend_sms_captcha', { seconds })
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    sendCaptcha (type) {
      if (!this[`canSend${type}Captcha`]) {
        return
      }

      if (type === 'SMS') {
        this.timer.interval = true

        getSmsCaptcha(1, this.auth.mobile).then(res => {
          let seconds = this.timer.seconds

          Toast(res.message)

          this.timer.interval = setInterval(() => {
            if (seconds <= 0) {
              this.setCountdownToSendCaptchaButtonText('SMS', 0)
              clearInterval(this.timer.interval)
              this.timer.interval = false
            } else {
              this.setCountdownToSendCaptchaButtonText('SMS', seconds)
            }
            seconds--
          }, 1000)
        }).catch(function (error) {
          Toast(error.message)
        })
      } else if (type === 'Email') {
        this.email_timer.interval = true

        getEmailCode(1, this.auth.email).then(res => {
          let seconds = this.email_timer.seconds

          Toast(res.message)

          this.email_timer.interval = setInterval(() => {
            if (seconds <= 0) {
              this.setCountdownToSendCaptchaButtonText('Email', 0)
              clearInterval(this.email_timer.interval)
              this.email_timer.interval = false
            } else {
              this.setCountdownToSendCaptchaButtonText('Email', seconds)
            }
            seconds--
          }, 1000)
        }).catch(function (error) {
          Toast(error.message)
        })
      }
    },
    signUp () {
      if (this.$v.$invalid) {
        return
      }

      Indicator.open()

      // registerByMobile(this.auth.mobile, this.auth.email, this.auth.password, this.auth.password_confirmation, this.auth.captcha, this.auth.captcha_email, this.auth.invitation_code).then(
      registerByMobile(this.auth.mobile, this.auth.password, this.auth.password_confirmation, this.auth.captcha, this.auth.invitation_code).then(
        response => {
          Indicator.close()
          this.saveAuthInfo({ token: response.result.token, info: response.result.info })
          this.$router.push({ name: 'MemberIndex' })
        },
        error => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    onAgreement () {
      this.$router.push({
        name: 'HomeDocument',
        query: { type: '' }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.send-sms-captcha-button {
  // margin-top: 0.5rem;
  width: auto;
}

.form {
  margin-bottom: 1rem;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  //background-color: #e93b3d;
  .section-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #ffffff;
    border-top: 1px solid #e8eaed;
    border-bottom: 1px solid #e8eaed;

    .input-wrapper {
      font-size: .7rem;
      display: flex;
      flex-direction: row;
      align-content: flex-start;
      align-items: center;
      background-color: #fff;
      height: 2.2rem;
      padding-left: 0.5rem;

      input {
        flex: 1;
      }

      .bottom-input {
        border-bottom-width: 0;
      }

      img {
        height: 1.75rem
      }
    }
  }

  .link-wrapper {
    height: 2.2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;

    span {
      font-size: 0.7rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .left-text {
      color: black;
    }

    .right-text {
      // color: $primaryColor;
      color: #F4C61F
    }
  }
}

.top-wrapper {
  margin-top: 0.5rem;
}

.bottom-wrapper {
  margin-top: 0.5rem;
}

.tips {
  color: #c3c3c3;
  font-size: 0.8rem;
  margin-left: 0.3rem;
  margin-top: 0.5rem;
  text-align: left;
}
.form-group {
  border: none;
  height: 1.5rem;
  background: transparent;
  display: flex;
  position: relative;
  margin-bottom: 10px;
  ::v-deep .mint-cell-title{
    font-size: 13px;
    width: 90px;
  }
  ::v-deep .mint-field {
    width: 100%;
    background: transparent;
  }
  ::v-deep .mint-cell-value {
    border-radius: 5px;
    height: 1.6rem;
    background: white;
  }
  ::v-deep .mint-field-state{
    margin-right: 5px;
    margin-left: 0px;
  }
  ::v-deep .form-error {
    padding-left: 0rem;
    padding-bottom: 0rem;
    background-color: transparent;
    position: absolute;
    bottom: -0.5rem;
    left: 6rem;
  }
}
.countdown {
  min-width: 4rem;
  margin-right: 0.5rem;
}
.mint-button--primary {
  background: #F4C61F !important;
  border-radius: 8px;
  box-shadow: 0px 1px 0px 0px #C59E1B;
}
.submitWidth {
  margin-bottom: 0px !important;
  margin-top: 10px !important;
  .mint-button--primary {
    width: 8.5rem;
    height: 1.8rem;
  }
}
.sms {
  ::v-deep .mint-cell {
    width: 100%
  }
}
</style>
